import React, { DetailedHTMLProps, HTMLAttributes, ReactNode } from 'react'

interface Props extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  children?: ReactNode
}

const View = ({ children, ...other }: Props): JSX.Element => {
  return <div {...other}>{children}</div>
}

export default View
